export enum AuthModeName {
  default = 'default',
  sso = 'sso',
}
